import { decode } from '@common-vue/util/src/modules/entities';

/**
 *
 * @param {string} productName
 * @param {string} brandName
 * @returns {string}
 */

export function getSeoAlt(productName, brandName) {
  if (!productName && !brandName) { return ''; }

  let altAttribute = '';
  if (brandName) {
    altAttribute += `${brandName} `;
    altAttribute = decode(altAttribute);
  }
  altAttribute += productName;
  return altAttribute;
}

export default getSeoAlt;
